import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route=createFileRoute('/system/users/accounts')({component:Outlet})
